import {gql} from "@apollo/client";

export const GET_CITY_LIST = gql`
    query getCityList($id: ID, $slug: String, $lat: Float, $lon: Float,  $distance: Int) {
        cities(id: $id, slug: $slug, lat: $lat, lon: $lon, distance: $distance, published: true) {
            id
            name
            slug
            lat
            lon
        }
    }
`
